<template>
  <v-container fluid>
    <h3 class="mb-5">Notaro vykdomasis įrašas</h3>

    <v-row>
      <v-col cols="12" md="6">
        <el-date-picker
          label="Notaro pranešimo skolininkui išsiuntimo data"
          tooltip="Hipoteka. Notaro vykdomasis įrašas. Notaro pranešimo skolininkui išsiuntimo data"
          :readonly="isReadonlyForm"
          v-model="formData.vyk_notaro_pranesimo_data"
        />
      </v-col>
      <v-col cols="12" md="6" v-if="false">
        <el-date-picker
          label="Notaro vykdomojo įrašo data"
          tooltip="Hipoteka. Notaro vykdomasis įrašas. Notaro vykdomojo įrašo data"
          :readonly="isReadonlyForm"
          v-model="formData.vyk_iraso_data"
        />
      </v-col>
      <v-col cols="12" md="12">
        <el-textarea
          label="Negrąžintos skolos dydis"
          tooltip="Hipoteka. Notaro vykdomasis įrašas. Negrąžintos skolos dydis"
          :counter="1000"
          :readonly="isReadonlyForm"
          v-model="formData.vyk_skola"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-money-field
          label="Priklausančių palūkanų dydis procentais"
          tooltip="Hipoteka. Notaro vykdomasis įrašas. Priklausančių palūkanų dydis"
          :readonly="isReadonlyForm"
          v-model="formData.vyk_palukanos"
        />
      </v-col>
      <v-col cols="12">
        <el-textarea
          label="Netesybos, kiti kreditoriaus nuostoliai"
          tooltip="Hipoteka. Notaro vykdomasis įrašas. Netesybos, kiti kreditoriaus nuostoliai"
          :counter="2000"
          :readonly="isReadonlyForm"
          v-model="formData.vyk_netesybos"
        />
      </v-col>
      <v-col cols="12" v-if="showObjektaiPerduotiKreditoriui">
        <el-checkbox
          class="mb-4 mt-0 pt-0"
          label="Neįvykdžius įkeitimu užtikrintos prievolės, hipotekos (įkeitimo) objektai perduoti įkeitimo kreditoriui"
          tooltip="Hipoteka. Notaro vykdomasis įrašas. Objektai perduoti įkeitimo kreditoriui"
          :readonly="isReadonlyForm"
          v-model="formData.vyk_objektai_perduoti_kreditoriui"
          @click.native="changeObjektaiPerduotiKreditoriui()"
        />
      </v-col>
      <v-col cols="12">
        <el-textarea
          label="Kita informacija"
          tooltip="Hipoteka. Notaro vykdomasis įrašas. Kita informacija"
          :counter="2000"
          :readonly="isReadonlyForm"
          v-model="formData.vyk_kita_informacija"
        />
      </v-col>
      <v-col cols="12">
        <el-textarea
          label="Duomenys apie išieškojimo iš įkeisto turto procedūras"
          tooltip="Hipoteka. Notaro vykdomasis įrašas. Duomenys apie išieškojimo iš įkeisto turto procedūras"
          :counter="2000"
          :readonly="isReadonlyForm"
          v-model="formData.vyk_isieskojimo_proceduros"
        />
      </v-col>
      <v-col cols="12" v-for="(item, index) in papildomi" :key="index">
        <el-textarea
          :label="item.pap_pavadinimas"
          tooltip="Hipoteka. Notaro vykdomasis įrašas. Papildomas laukas"
          :counter="4000"
          :readonly="isReadonlyForm"
          v-model="item.pap_informacija"
          append-outer-icon="mdi-delete"
          @clickAppendOuter="deletePapildomasLaukas(index)"
        />
      </v-col>
    </v-row>

    <h3 class="mt-2">
      Kreditorius(-ai), kurių prašymu atliktas notaro vykdomasis įrašas<el-need
        v-if="!isReadonlyForm"
      />
    </h3>
    <hipoteka-asmenys
      :asmuo-role="kreditoriusRole"
      :vykdomasis-kreditoriai="formData.kreditoriai_pazymeti"
      :readonly="isReadonlyForm"
      :toolbar="false"
      @updateVykdomasisKreditoriai="updateVykdomasisKreditoriai"
    />

    <h3 class="mt-2">
      Priskirtas administratorius
    </h3>
    <hipoteka-asmenys
      :asmuo-role="administratoriusRole"
      :vykdomasis-id="vykdomasisID"
      :readonly="isReadonlyForm"
    />

    <v-footer class="form-footer mt-3">
      <el-button
        v-if="!isReadonlyForm"
        primary
        @click.native="saveData()"
        :loading="loading"
        >Saugoti</el-button
      >
      <el-button
        v-if="!isReadonlyForm"
        @click.native="cancelData()"
        :loading="loading"
        >Atšaukti</el-button
      >
      <el-button
        v-if="!isReadonlyForm"
        @click.native="openPapildomasLaukas()"
        :loading="adding"
        >Pridėti papildomą lauką</el-button
      >
      <v-spacer></v-spacer>
      <el-button
        v-if="!isReadonlyForm"
        primary
        @click.native="checkErrorsClick()"
        :loading="loading"
        >Tikrinti</el-button
      >
    </v-footer>

    <modal-papildomas-laukas
      :key="`nvipap-${refreshPapildomasLaukas}`"
      tooltip="Hipoteka. Notaro vykdomasis įrašas. Modalas papildomas laukas"
      v-model="showPapildomasLaukas"
      @confirmPapildomasLaukas="confirmPapildomasLaukas"
    />
    <modal-delete
      title="Šalinti lauką?"
      :text="`Ar norite pašalinti lauką <strong>${modalDeleteVardas}</strong>?`"
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import HipotekaMap from './hipotekaMap'
import HipotekaAsmenys from './HipotekaAsmenys'
import ModalPapildomasLaukas from '../modals/ModalPapildomasLaukas'
import ModalDelete from '../modals/ModalDelete'
import unsavedData from '../../mixins/unsavedData'
import checkErrors from '../../mixins/checkErrors'

export default {
  name: 'HipotekaVykdomasis',
  components: {
    HipotekaAsmenys,
    ModalPapildomasLaukas,
    ModalDelete,
  },
  mixins: [unsavedData, checkErrors],
  props: {
    vykdomasis: Object,
    readonlyForm: { type: Boolean, default: false },
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      loading: false,
      formData: {},
      pagrindimas: [],
      papildomi: [],
      adding: false,
      refreshPapildomasLaukas: 0,
      showPapildomasLaukas: false,
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      turiKilnojamaTurta: null,
    }
  },
  computed: {
    ...mapGetters(['objektasID', 'hipotekaTipas', 'hipotekaReadonly']),
    isReadonlyForm() {
      return this.hipotekaReadonly || this.readonlyForm
    },
    kreditoriusRole() {
      return HipotekaMap['asmenysRoles'].nvi_kreditorius
    },
    administratoriusRole() {
      return HipotekaMap['asmenysRoles'].administratorius
    },
    vykdomasisID() {
      return this.formData.vyk_id
    },
    showObjektaiPerduotiKreditoriui() {
      return this.turiKilnojamaTurta
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.$axios
        .get(`objektas/${this.objektasID}/vykdomasisirasas`)
        .then(res => {
          this.formData = res.data.vykdomasis_irasas
          this.pagrindimas = res.data.pagrindimas
          this.papildomi = this.formData.papildomi_laukai
          this.turiKilnojamaTurta = this.formData.turi_kilnojama_turta
          this.initialForm()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    saveData(toRoute, afterSave) {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true
          const data = {
            obj_id: this.objektasID,
            ...this.formData,
          }

          this.$axios
            .post(`objektas/${this.objektasID}/vykdomasisirasas`, data)
            .then(res => {
              window._VMA.$emit('DATA_OK', 'Duomenys išsaugoti')
              if (toRoute) {
                this.goToRoute()
              } else {
                this.initialForm()
                if (afterSave === 'checkErrors') {
                  this.checkErrors()
                }
              }
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
          this.$root.$emit('cancelTabNavigation')
        }
      })
    },
    cancelData() {
      this.getData()
    },
    updateVykdomasisKreditoriai(list) {
      this.formData.kreditoriai_pazymeti = list
    },
    checkErrorsClick() {
      this.saveData(null, 'checkErrors')
    },
    openPapildomasLaukas() {
      this.refreshPapildomasLaukas++
      this.showPapildomasLaukas = true
    },
    confirmPapildomasLaukas(newLaukas) {
      if (newLaukas !== '') {
        this.papildomi.push({
          pap_id: null,
          pap_pavadinimas: newLaukas,
          pap_informacija: null,
        })
      }
    },
    deletePapildomasLaukas(index) {
      this.modalDeleteVardas = this.papildomi[index].pap_pavadinimas ?? ''
      this.modalDeleteItem = { index: index }
      this.showDelete = true
    },
    confirmDelete(item) {
      this.papildomi.splice(item.index, 1)
    },
    changeObjektaiPerduotiKreditoriui() {
      if (!this.formData.vyk_objektai_perduoti_kreditoriui) {
        return
      }

      this.$axios
        .get(
          `objektas/${this.objektasID}/vykdomasisirasas/${this.formData.vyk_id}/objektai-kreditoriui`
        )
        .then(res => {
          this.formData.vyk_isieskojimo_proceduros = this.parseObjektaiKreditoriui(
            this.formData.vyk_isieskojimo_proceduros,
            res.data
          )
          window._VMA.$emit('DATA_OK', res.data.message)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          //
        })
    },
    parseObjektaiKreditoriui(oldText, data) {
      return (
        (oldText ? oldText + '\n' : '') +
        this.parseKreditorius(data.kreditoriai) +
        '\n' +
        'Daiktai:' +
        '\n' +
        this.parseTurtas(data.turtai)
      )
    },
    parseKreditorius(newText) {
      return (
        'Kreditorius, kuriam perduoti daiktai - ' +
        newText
          .map(item => {
            return `${item.asm_asmens_kodas} ${item.asm_pavadinimas}`
          })
          .join(', ')
      )
    },
    parseTurtas(newText) {
      return newText
        .map(item => {
          return `${item.eil_nr}. ${
            item.tur_identifikatorius ? item.tur_identifikatorius + ', ' : ''
          }${item.trs_pavadinimas}, ${
            item.kita_informacija
              ? item.kita_informacija.replace(/(.{130})..+/, '$1...')
              : ''
          }`
        })
        .join('\n')
    },
  },
}
</script>
